<template>
    <div v-if="data" class="c-hero-card">
        <div class="c-hero-card__inner">
            <card-video v-view.reveal="0.8" bg="bright" :data="data.primary" />
        </div>
    </div>
</template>

<script>
import CardVideo from "objects/Card/CardVideo";
export default {
    components: {
        CardVideo
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss">
.c-hero-card {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-self: center;
    margin: 0px 0px 0px 0px;
    width: 100%;

    @media #{$breakpoint-horizontal} {
        flex-direction: column;
        width: auto;
        margin: 0px 0px 0px -2.5%; // make sure the card is a bit overlapping the hero image
    }
    &__inner {
        @media #{$breakpoint-vertical} {
            margin-top: -2.5rem;
        }
    }
}
</style>
